/** Dark loading placeholder for the Netflix-style course details page. */
export function TeacherCourseDetailsSkeleton() {
  return (
    <div
      className="teacher-course-details teacher-course-details--loading"
      aria-busy="true"
      aria-label="Loading course details"
    >
      <div className="teacher-course-details-hero teacher-course-details-hero--loading">
        <div className="teacher-course-details-hero-inner">
          <div className="course-details-skeleton-breadcrumb">
            <div className="skeleton skeleton--line skeleton--line-sm" />
          </div>
          <div className="course-details-skeleton-badges">
            <div className="skeleton course-details-skeleton-pill" />
            <div className="skeleton course-details-skeleton-pill" />
          </div>
          <div className="skeleton course-details-skeleton-title" />
          <div className="skeleton skeleton--line skeleton--line-lg course-details-skeleton-lede" />
          <div className="skeleton skeleton--line skeleton--line-md course-details-skeleton-lede-2" />
          <div className="course-details-skeleton-stats">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="course-details-skeleton-stat">
                <div className="skeleton skeleton--line skeleton--line-sm" />
                <div className="skeleton course-details-skeleton-stat-value" />
              </div>
            ))}
          </div>
          <div className="course-details-skeleton-actions">
            <div className="skeleton skeleton--button" />
            <div className="skeleton skeleton--button course-details-skeleton-button-secondary" />
          </div>
        </div>
      </div>

      <section className="teacher-course-details-section teacher-course-details-pad">
        <div className="skeleton skeleton--panel-title" />
        <ol className="course-details-skeleton-lessons">
          {[0, 1, 2].map((i) => (
            <li key={i} className="course-details-skeleton-lesson">
              <div className="skeleton course-details-skeleton-lesson-num" />
              <div className="skeleton skeleton--lesson-icon skeleton--lesson-icon-sm" />
              <div className="course-details-skeleton-lesson-copy">
                <div className="skeleton skeleton--line skeleton--line-lg" />
                <div className="skeleton skeleton--line skeleton--line-sm" />
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="teacher-course-details-section teacher-course-details-pad">
        <div className="skeleton skeleton--panel-title skeleton--panel-title-wide" />
        <div className="course-details-skeleton-cohorts">
          {[0, 1].map((i) => (
            <div key={i} className="course-details-skeleton-cohort">
              <div className="skeleton skeleton--line skeleton--line-lg" />
              <div className="skeleton course-details-skeleton-pill" />
              <div className="skeleton skeleton--line skeleton--line-sm" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
